import {
  GH_DRAG_MIME_TEXT,
  buildGhTextPayload,
  dataTransferHasGhMime,
  readGhDragPayload,
  setGhTextDragData,
} from '@/shared/helpers/generationHistoryDrag';

export const GH_TEXT_FIELD = {
  CATEGORY_SHAPE: 'category_shape',
  CONCEPT: 'concept',
  BRAND: 'brand',
  COMPANY: 'company',
  PROMPT: 'prompt',
  MISSION: 'mission',
};

/** In-page session so field type is readable during dragover (getData is empty). */
let activeGhTextDragSession = null;

export function setGhAssistTextDragData(dataTransfer, payload) {
  activeGhTextDragSession = payload || null;
  setGhTextDragData(dataTransfer, payload);
}

export function buildGhAssistTextPayload({ text, itemId, sourceType, field }) {
  return {
    ...buildGhTextPayload({ text, itemId, sourceType }),
    field: field || '',
  };
}

export function getGhTextDragSession() {
  return activeGhTextDragSession;
}

export function clearGhTextDragSession() {
  activeGhTextDragSession = null;
}

export function resolveGhTextDragField(dataTransfer) {
  const session = activeGhTextDragSession;
  if (session && session.field) {
    return session.field;
  }
  const payload = readGhDragPayload(dataTransfer);
  return (payload && payload.field) || '';
}

export function canDropGhTextOnAssistField(dataTransfer, targetField) {
  if (!dataTransferHasGhMime(dataTransfer, GH_DRAG_MIME_TEXT)) {
    return false;
  }
  const field = resolveGhTextDragField(dataTransfer);
  if (!field || field === GH_TEXT_FIELD.PROMPT) {
    return targetField === GH_TEXT_FIELD.CONCEPT;
  }
  return field === targetField;
}
